import { Component, OnInit } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { UserPermission } from 'src/app/enums/enums';
import { PermissionService } from 'src/app/services/app/permission-access-service/permissionBased.service';
import { PrimaryDiagnosisService } from 'src/app/services/core/primary-diagnosis/primary-diagnosis.service';
import { NUMBER_OF_RECORDS } from 'src/app/utils/common.utils';
@UntilDestroy()
@Component({
  selector: 'app-primary-diagnosis-list',
  templateUrl: './primary-diagnosis-list.component.html',
  styleUrls: ['./primary-diagnosis-list.component.css']
})
export class PrimaryDiagnosisListComponent implements OnInit {
  primaryDiagnosisList: any;
  selectedStatus = '';
  currentPage: number = 1;
  totalPages = 0;
  totalResults = 0;
  search: any;
  status = true
  numberOfRecords = NUMBER_OF_RECORDS
  userPermission = UserPermission;
  diagnosisModalObj: any;

  constructor(
    private primaryDiagnosisService: PrimaryDiagnosisService,
    public permissionService: PermissionService
  ) { }

  ngOnInit() {
    this.getPrimaryDiagnosis(this.currentPage)
  }

  getPrimaryDiagnosis(page: number) {
    const queryparams = {
      limit: 50,
      page,
      isActive: this.status
    }
    this.primaryDiagnosisService.get(queryparams)
      .pipe(untilDestroyed(this)).subscribe((data: any) => {
        if (data && data.results) {
          this.primaryDiagnosisList = data.results;
          this.totalPages = data.totalPages;
          this.totalResults = data.totalResults;
        }
      })
  }

  onPageChange(page: number) {
    this.currentPage = page;
    this.getPrimaryDiagnosis(page);
  }

  onSelectStatus(event: any): void {
    this.status = event.target.value === 'true';
    this.getPrimaryDiagnosis(this.currentPage = 1)
  }

  openModal(los: any) {
    this.diagnosisModalObj = los;
  }

  onSave(evt: any) {
    if (evt) {
      const idx = this.primaryDiagnosisList.findIndex((fs: any) => fs.id === evt.id);
      if (this.status === evt.isActive) {
        this.primaryDiagnosisList[idx] = evt;
      } else {
        this.primaryDiagnosisList.splice(idx, 1);
      }
    }
    this.diagnosisModalObj = null;
  }

  onCloseModal() {
    this.diagnosisModalObj = null;
  }
}
